export const config = {
    baseUrl: `//${window.location.hostname}:5000`,
    version: 1.33
}
